module.exports = __webpack_public_path__ + "img/health2.322d9e52.png";